export class SaveUserDto {
    id: number;
    username: string;
    enabled: boolean;
    roles: any; // received list of objects, send a list of strings (for save)
    password?: string;
    nickname?: string;
    pin?: string;
}
